import {
  ConnectedAppProvider,
  ConnectedAppReservedProviderTypes
} from '~/api/types/connectedAppProviders.ts';
import logger from '~/utils/logger';

const doesProviderHaveOauth2 = (provider: ConnectedAppProvider) => {
  return provider.authPatterns.some(
    (pattern) => pattern.type === ConnectedAppReservedProviderTypes.OAUTH2
  );
};

const getConnectionTypeForCreation = (provider: ConnectedAppProvider) => {
  if (provider.authPatterns.length === 0) {
    logger.error('No auth patterns found for provider', provider);
    throw new Error(`Provider ${provider.identifier} has no auth patterns`);
  }
  if (doesProviderHaveOauth2(provider)) {
    return ConnectedAppReservedProviderTypes.OAUTH2;
  }
  return provider.authPatterns[0].type;
};

export { getConnectionTypeForCreation };
